import {Component, inject, OnInit, Renderer2, signal, ViewChild} from '@angular/core';
import {TableComponent, TableOptions} from "@shared/components";
import {APIService} from '@core/services';
import {PatientService} from '@core/services/patient.service';
import {Allergy} from '@core/classes/tables/allergy';
import {HttpHeaders} from '@angular/common/http';
import {MedicalDevice} from '@core/classes/tables/medical-device';
import {NavigationEnd, Router} from '@angular/router';
import {
  ProblemDiagnosisStatusActionComponent
} from '@modules/cy/patient/ps/components/problems-diagnoses/actions/problem-diagnosis-status-action/problem-diagnosis-status-action.component';
import {
  AddProblemDiagnosisComponent
} from '@modules/cy/patient/ps/components/problems-diagnoses/actions/add-problem-diagnosis/add-problem-diagnosis.component';
import {
  ProblemDiagnosisUnknownValuesComponent
} from '@modules/cy/patient/ps/components/problems-diagnoses/actions/problem-diagnosis-unknown-values/problem-diagnosis-unknown-values.component';
import {
  DeviceImplantUnknownValuesComponent
} from '@modules/cy/patient/ps/components/devices-implants/actions/device-implant-unknown-values/device-implant-unknown-values.component';
import {
  DeviceImplantStatusActionComponent
} from '@modules/cy/patient/ps/components/devices-implants/actions/device-implant-status-action/device-implant-status-action.component';
import {
  AddDeviceImplantComponent
} from '@modules/cy/patient/ps/components/devices-implants/actions/add-device-implant/add-device-implant.component';
import {CurrentIllness} from '@core/classes/tables/current-illness';
import {Subject, takeUntil} from 'rxjs';

@Component({
  selector: 'ncp-devices-implants',
    imports: [
        TableComponent
    ],
  templateUrl: './devices-implants.component.html',
  styleUrl: './devices-implants.component.scss',
})
export class DevicesImplantsComponent implements OnInit {
  @ViewChild('devicesImplants') public allergiesEl!: TableComponent<MedicalDevice>;
  protected readonly router = inject(Router);
  protected apiService = inject(APIService);
  protected patientService = inject(PatientService);
  protected renderer2 = inject(Renderer2);

  private subscription: any;
  private destroy$ = new Subject<void>();

  protected options = signal<TableOptions<MedicalDevice>>(
    new TableOptions<MedicalDevice>({
      id: 'devicesImplants',
      type: 'DevicesImplants',
      interface: MedicalDevice,
      autoLoadData: false,
      ignoreColumns: (this.router.url === '/cy/patient/ps/create' || this.router.url === '/cy/patient/ps/edit')? [] : ['status'],
      pagination: {
        itemsPerPage: 10,
        pageNumber: 1,
        totalItems: 0,
      },
      searchComponent: null,
    })
  );

  ngOnInit(): void {
    this.getData(
      (this.router.url === '/cy/patient/ps/edit' || this.router.url === '/cy/patient/ps/create') ? -1 : 0,
      (this.router.url === '/cy/patient/ps/edit' || this.router.url === '/cy/patient/ps/create') ? -1 : 0
    );

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (this.subscription) {
          this.subscription.unsubscribe();
        }
      }
    });
  }

  protected getData = (mode: number = 0, status: number = 0) => {
    this.subscription = this.apiService
      .call({
        path: '/get-medical-devices',
        headers: new HttpHeaders().set('pToken', this.patientService.pToken || ''),
        body: {
          mode: mode,
          status: status,
          version_id: this.patientService.patient?.version?.id || -1
        }
      })?.pipe(takeUntil(this.destroy$)).subscribe((response: any) => {
      if(response && response.status === 1) {
        this.options.set(
          new TableOptions<MedicalDevice>({
            id: 'devicesImplants',
            type: 'DevicesImplants',
            interface: MedicalDevice,
            data: response.data,
            autoLoadData: false,
            ignoreColumns: (this.router.url === '/cy/patient/ps/create' || this.router.url === '/cy/patient/ps/edit') ? [] : ['status'],
            actionsComponent: (this.router.url === '/cy/patient/ps/create' || this.router.url === '/cy/patient/ps/edit') ? DeviceImplantStatusActionComponent : undefined,
            extraComponent: (this.router.url === '/cy/patient/ps/create' || this.router.url === '/cy/patient/ps/edit') ? AddDeviceImplantComponent : undefined,
            extraLeftComponent: DeviceImplantUnknownValuesComponent,
            pagination: {
              itemsPerPage: 10,
              pageNumber: 1,
              totalItems: response.data.length,
            },
            otherData: response.unknown,
            renderCustomRow: (td: HTMLTableCellElement, row: {}, item: string) => {
              const data = row as MedicalDevice;
              if (item === 'status') {
                td.innerHTML = '';

                let iEl = this.renderer2.createElement('h2');
                if(data.status === 1) {
                  this.renderer2.addClass(iEl, 'bi');
                  this.renderer2.addClass(iEl, 'bi-eye');
                  this.renderer2.addClass(iEl, 'text-primary');
                } else {
                  this.renderer2.addClass(iEl, 'bi');
                  this.renderer2.addClass(iEl, 'bi-eye-slash');
                  this.renderer2.addClass(iEl, 'text-secondary');
                }
                this.renderer2.appendChild(td, iEl);
              }
            },
            searchComponent: null,
          })
        )
      }
    })
  }
}
